export default __webpack_public_path__ + "static/media/logo.ce9a93eb.svg";